/**
 * The current status of the RFI.
 * @export
 * @enum {string}
 */
export enum RfiStatus {
  Draft = 'draft',
  Submitted = 'submitted',
  Open = 'open',
  OpenRev1 = 'openRev1',
  OpenRev2 = 'openRev2',
  Rejected = 'rejected',
  RejectedRev1 = 'rejectedRev1',
  RejectedManager = 'rejectedManager',
  Answered = 'answered',
  AnsweredRev1 = 'answeredRev1',
  AnsweredManager = 'answeredManager',
  Closed = 'closed',
  Void = 'void',
}

export enum NormalizeRfiStatus {
  Draft = 'draft',
  Submitted = 'submitted',
  Open = 'open',
  Answered = 'answered',
  Closed = 'closed',
  Rejected = 'rejected',
  Void = 'void',
}

/**
 * The cost impact status of the RFI. Possible values: ``Yes``, ``No``, ``Unknown``.
 * @export
 * @enum {string}
 */
export enum RfiCostImpact {
  Yes = 'Yes',
  No = 'No',
  Unknown = 'Unknown',
}
/**
 * The schedule impact status of the RFI. Possible values: ``Yes``, ``No``, ``Unknown``.
 * @export
 * @enum {string}
 */
export enum RfiScheduleImpact {
  Yes = 'Yes',
  No = 'No',
  Unknown = 'Unknown',
}
/**
 * The priority status of the RFI. Possible values: ``High``, ``Normal``, ``Low``.
 * @export
 * @enum {string}
 */
export enum RfiPriority {
  High = 'High',
  Normal = 'Normal',
  Low = 'Low',
}
/**
 * The disciplines of the RFI
 * @export
 * @enum {string}
 */
export enum RfiDiscipline {
  Architectural = 'Architectural',
  CivilSite = 'Civil/Site',
  Concrete = 'Concrete',
  Electrical = 'Electrical',
  ExteriorEnvelope = 'Exterior Envelope',
  FireProtection = 'Fire Protection',
  InteriorFinishes = 'Interior/Finishes',
  Landscaping = 'Landscaping',
  Masonry = 'Masonry',
  Mechanical = 'Mechanical',
  Plumbing = 'Plumbing',
  Structural = 'Structural',
  Other = 'Other',
}
/**
 * The categories of the RFI
 * @export
 * @enum {string}
 */
export enum RfiCategory {
  CodeCompliance = 'Code Compliance',
  Constructability = 'Constructability',
  DesignCoordination = 'Design Coordination',
  DocumentationConflict = 'Documentation Conflict',
  DocumentationIncomplete = 'Documentation Incomplete',
  Fieldcondition = 'Field condition',
  Other = 'Other',
}

export enum UserRole {
  projectUser = 'project_user',
  projectAdmin = 'project_admin',
}

export enum WorkflowType {
  US = 'US',
  EU = 'EU',
}

export enum WorkflowRole {
  ProjectSC = 'projectSC',
  ProjectGC = 'projectGC',
  ProjectCM = 'projectCM',
  ProjectArch = 'projectArch',
}

/**
 * @export
 * @enum {string}
 */
export enum PushpinAttributesType {
  TwoDRasterPushpin = 'TwoDRasterPushpin',
  TwoDVectorPushpin = 'TwoDVectorPushpin',
}

export enum UrnType {
  Oss = 'oss',
  Dm = 'dm',
}
